var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfCancelled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.003,
    height: 30.003,
    viewBox: "0 0 30.003 30.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23067",
    d: "M64 0v30h17.5l7.5-7.5V0z",
    transform: "translate(-58.999)",
    style: {
      fill: "#efeeee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23068",
    d: "M288 288v7.5l7.5-7.5z",
    transform: "translate(-265.497 -265.497)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23069",
    d: "M192 295.5h7.5V288z",
    transform: "translate(-176.998 -265.497)",
    style: {
      fill: "#dededd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23070",
    d: "M0 96v8.751h20V96z",
    transform: "translate(0 -88.499)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Pdf",
    transform: "translate(10 14.7)",
    style: {
      fill: "#fff",
      fontSize: 8,
      fontFamily: "HelveticaNeue-CondensedBold,Helvetica Neue",
      fontWeight: 700,
      letterSpacing: ".08em"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -6.864,
    y: 0
  }, "PDF"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfCancelled);
export default __webpack_public_path__ + "static/media/pdf-cancelled.b09f96fa1a81eba270810843ff2afc72.svg";
export { ForwardRef as ReactComponent };